import type { SharedSessionData } from '../types';

import { ACCOUNT_SLOT, loadSlotSession } from './multiaccount';

export type TelegramApiCredentials = {
  apiId: number;
  apiHash: string;
};

export function getTelegramApiCredentials(): TelegramApiCredentials {
  const stored = getStoredApiCredentials();
  if (stored) {
    return stored;
  }

  const apiId = Number(process.env.TELEGRAM_API_ID);
  const apiHash = process.env.TELEGRAM_API_HASH;

  if (!apiId || !Number.isFinite(apiId) || !apiHash) {
    throw new Error('Telegram API credentials are not configured');
  }

  return {
    apiId,
    apiHash,
  };
}

function getStoredApiCredentials(): TelegramApiCredentials | undefined {
  const session = loadSlotSession(ACCOUNT_SLOT);
  return parseApiCredentials(session);
}

function parseApiCredentials(session?: SharedSessionData): TelegramApiCredentials | undefined {
  if (!session?.apiHash) {
    return undefined;
  }

  const apiId = Number(session.apiId);
  if (!apiId || !Number.isFinite(apiId)) {
    return undefined;
  }

  return {
    apiId,
    apiHash: session.apiHash,
  };
}
